const fileTypes = {
  image: 'image/*,image/heic',
  word: 'application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  spreadsheet:
    'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  presentation:
    'application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation',
  pdf: 'application/pdf',
  video: 'video/*',
  audio: 'audio/*',
};

const allFileTypes = Object.values(fileTypes).join(',');

export const convertType = (types) => {
  if (Array.isArray(types)) {
    const output = [];
    types.forEach((type) => {
      if (Object.keys(fileTypes).includes(type)) output.push(fileTypes[type]);
    });
    return output.join(',');
  }
  if (types === 'image') return 'image/*';
  if (types === true) return allFileTypes;
  return allFileTypes;
};
